import type { Workspace } from '@store/reducers/dashboard/types'
import type React from 'react'

import { TemplatesLink } from '../TemplatesLink'
import {
  ArchiveFolder,
  CreateFolder,
  CustomFolders,
  DashboardFolder,
} from './components'
import { useFolderMenu, useFolders } from './hooks'
import css from './styles.module.css'

type Props = {
  workspace: Workspace
  activeFolder: string | null
  canCreate: boolean
  showFolderAccess: boolean
}

export const PROJECTS_COUNT_CLASS_NAME = css.project_count

export const Folders: React.FC<Props> = ({
  workspace,
  activeFolder,
  canCreate,
  showFolderAccess,
}) => {
  const {
    dashboard,
    renamingFolder,
    archive,
    workspaceId,
    lastIdx,
    folders,
    handleHideInput,
    handleShowInput,
  } = useFolders(workspace)

  const { onClick } = useFolderMenu()

  const handleOnClick = (keys: string[]) => {
    onClick(keys, workspaceId, handleShowInput)
  }

  return (
    <>
      <DashboardFolder
        activeFolder={activeFolder}
        folder={dashboard}
        workspaceId={workspaceId}
      />

      <TemplatesLink id={workspaceId} />

      <CustomFolders
        folders={folders}
        workspaceId={workspaceId}
        lastIdx={lastIdx}
        activeFolder={activeFolder}
        renamingFolder={renamingFolder}
        onHideInput={handleHideInput}
        onClick={handleOnClick}
        showFolderAccess={showFolderAccess}
      />

      {canCreate && (
        <CreateFolder workspaceId={workspace.id} order={lastIdx + 1} />
      )}

      <ArchiveFolder
        activeFolder={activeFolder}
        folder={archive}
        workspaceId={workspaceId}
      />
    </>
  )
}
